import { SeverityLevel } from '@microsoft/applicationinsights-web';
import React from 'react';
import { reactPlugin } from '../../../utils/app-insights';
import GeneralErrorPage from '../error/generalErrorPage';
import InvalidOfferErrorPage from '../error/invalidOfferErrorPage';
import { LeaseApplicationError } from './error';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = {
    hasError: false,
    error: null,
  };

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Update state to trigger re-render with fallback UI
    this.setState({
      hasError: true,
      error,
    });

    // Track exception in Application Insights
    reactPlugin.trackException({
      error,
      exception: error,
      severityLevel: SeverityLevel.Error,
      properties: errorInfo,
    });
  }

  render() {
    if (this.state.hasError && this.state.error) {
      if (this.state.error instanceof LeaseApplicationError) {
        return <InvalidOfferErrorPage />;
      }
      return <GeneralErrorPage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
